import { Component, Inject, OnInit } from '@angular/core';
import Env from '@ridango/core/env';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

interface RetailersZone {
    id: string;
    titleKey: string;
    contentKey: string;
}

@Component({
    templateUrl: './retailers-page.component.html',
    styleUrls: ['./retailers-page.component.scss']
})
export class RetailersPageComponent implements OnInit {
    zones: RetailersZone[] = [
        { id: 'zone1', titleKey: 'RETAILERS_ZONE1_TITLE', contentKey: 'RETAILERS_ZONE1' },
        { id: 'zone2', titleKey: 'RETAILERS_ZONE2_TITLE', contentKey: 'RETAILERS_ZONE2' },
        { id: 'zone3', titleKey: 'RETAILERS_ZONE3_TITLE', contentKey: 'RETAILERS_ZONE3' },
        { id: 'zone4', titleKey: 'RETAILERS_ZONE4_TITLE', contentKey: 'RETAILERS_ZONE4' }
    ];

    selectedRegion$?: Observable<string>;
    regionContent$?: Observable<string>;

    private selectedRegionSubject?: BehaviorSubject<string>;

    constructor(@Inject('ENV') public env: Env) {
        if (this.env.USE_RETAILERS_WITH_MENU) {
            this.selectedRegionSubject = new BehaviorSubject<string>(this.zones[0].id);
            this.selectedRegion$ = this.selectedRegionSubject.asObservable();

            this.regionContent$ = this.selectedRegion$.pipe(
                map((regionId) => {
                    const zone = this.zones.find((z) => z.id === regionId);
                    return zone ? zone.contentKey : this.zones[0].contentKey;
                })
            );
        }
    }

    ngOnInit(): void {
        window.scrollTo({ top: 0 });
    }

    selectRegion(regionId: string): void {
        this.selectedRegionSubject?.next(regionId);
    }
}
